import script from "./ThemeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeButton.vue?vue&type=script&setup=true&lang=js"

import "./ThemeButton.vue?vue&type=style&index=0&id=2a11f92c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a11f92c"]])

export default __exports__